<script setup>
  import { computed } from 'vue';
  import { useDateHelper } from "@/composables/useDateHelper";
  import { useSpotStore } from "@/stores/SpotStore";

  const dateHelper = useDateHelper();

  const spotStore = useSpotStore();

  const apiData = computed(() => spotStore.stationApiDataValues);
  
  const timestamp = computed(() => {
    if (!apiData.value.timestamp) return 'N/A';

    let apiTimestamp;
    let relativeTimestamp = 'N/A';

    try {
      apiTimestamp = dateHelper.datetimeToISOFormat(apiData.value.timestamp, spotStore.localUTCOffset);
      relativeTimestamp =  dateHelper.timeFromNow(apiTimestamp);
    } catch (e) {
      console.warn('Error parsing api timestamp: ', apiData.value.timestamp, e);
    }

    return relativeTimestamp
  });
</script> 

<template>
    <p class="jwx-current-conditions-last-update"><span class="jwx-current-conditions-last-update__label">Last Update:</span> <span v-html="timestamp" class="jwx-current-conditions-last-update__timestamp"></span></p>
</template>